"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toCSV = exports.string2csv = exports.jsonsHeaders = exports.jsons2csv = exports.jsons2arrays = exports.joiner = exports.isSafari = exports.isJsons = exports.isArrays = exports.getHeaderValue = exports.elementOrEmpty = exports.buildURI = exports.arrays2csv = void 0;
/**
 * Simple safari detection based on user agent test
 */
const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
exports.isSafari = isSafari;
const isJsons = array => Array.isArray(array) && array.every(row => typeof row === "object" && !(row instanceof Array));
exports.isJsons = isJsons;
const isArrays = array => Array.isArray(array) && array.every(row => Array.isArray(row));
exports.isArrays = isArrays;
const jsonsHeaders = array => Array.from(array.map(json => Object.keys(json)).reduce((a, b) => new Set([...a, ...b]), []));
exports.jsonsHeaders = jsonsHeaders;
const jsons2arrays = (jsons, headers) => {
  headers = headers || jsonsHeaders(jsons);

  // allow headers to have custom labels, defaulting to having the header data key be the label
  let headerLabels = headers;
  let headerKeys = headers;
  if (isJsons(headers)) {
    headerLabels = headers.map(header => header.label);
    headerKeys = headers.map(header => header.key);
  }
  const data = jsons.map(object => headerKeys.map(header => getHeaderValue(header, object)));
  return [headerLabels, ...data];
};
exports.jsons2arrays = jsons2arrays;
const getHeaderValue = (property, obj) => {
  const foundValue = property.replace(/\[([^\]]+)]/g, ".$1").split(".").reduce(function (o, p, i, arr) {
    // if at any point the nested keys passed do not exist, splice the array so it doesnt keep reducing
    const value = o[p];
    if (value === undefined || value === null) {
      arr.splice(1);
    } else {
      return value;
    }
  }, obj);
  // if at any point the nested keys passed do not exist then looks for key `property` in object obj
  return foundValue === undefined ? property in obj ? obj[property] : "" : foundValue;
};
exports.getHeaderValue = getHeaderValue;
const elementOrEmpty = element => typeof element === "undefined" || element === null ? "" : element;
exports.elementOrEmpty = elementOrEmpty;
const joiner = function (data) {
  let separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ",";
  let enclosingCharacter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '"';
  return data.filter(e => e).map(row => row.map(element => elementOrEmpty(element)).map(column => "".concat(enclosingCharacter).concat(column).concat(enclosingCharacter)).join(separator)).join("\n");
};
exports.joiner = joiner;
const arrays2csv = (data, headers, separator, enclosingCharacter) => joiner(headers ? [headers, ...data] : data, separator, enclosingCharacter);
exports.arrays2csv = arrays2csv;
const jsons2csv = (data, headers, separator, enclosingCharacter) => joiner(jsons2arrays(data, headers), separator, enclosingCharacter);
exports.jsons2csv = jsons2csv;
const string2csv = (data, headers, separator, enclosingCharacter) => headers ? "".concat(headers.join(separator), "\n").concat(data) : data.replace(/"/g, '""');
exports.string2csv = string2csv;
const toCSV = (data, headers, separator, enclosingCharacter) => {
  if (isJsons(data)) return jsons2csv(data, headers, separator, enclosingCharacter);
  if (isArrays(data)) return arrays2csv(data, headers, separator, enclosingCharacter);
  if (typeof data === "string") return string2csv(data, headers, separator);
  throw new TypeError("Data should be a \"String\", \"Array of arrays\" OR \"Array of objects\" ");
};
exports.toCSV = toCSV;
const buildURI = (data, uFEFF, headers, separator, enclosingCharacter) => {
  const csv = toCSV(data, headers, separator, enclosingCharacter);
  const type = isSafari() ? "application/csv" : "text/csv";
  const blob = new Blob([uFEFF ? "\uFEFF" : "", csv], {
    type
  });
  const dataURI = "data:".concat(type, ";charset=utf-8,").concat(uFEFF ? "\uFEFF" : "").concat(csv);
  const URL = window.URL || window.webkitURL;
  return typeof URL.createObjectURL === "undefined" ? dataURI : URL.createObjectURL(blob);
};
exports.buildURI = buildURI;